import { Suspense } from 'react';
import { Loading } from './Loading';

export const Load = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};
